<template>
  <div class="hzc-industry-dynamics">
    <div>当前位置：<span @click="back" style="cursor: pointer">氢能</span> > 燃料电池</div>
    <div class="content">
      <div class="header">
        <em></em>
        <p>燃料电池</p>
        <div class="btn fr" @click="search">搜索</div>
        <input v-if="queryParams['sourceType'] !== '10'" class="fr" v-model="queryParams.likeTitleName" type="text" placeholder="请输入关键词">
        <input v-else class="fr" v-model="query.likeFileTitle" type="text" placeholder="请输入关键词">
      </div>
      <div class="tabs">
        <div @click="changeTabs('108')" :class="{'hover':queryParams.sourceType === '108'}">公告车型数</div>
        <div @click="changeTabs('109')" :class="{'hover':queryParams.sourceType === '109'}">燃料电池汽车产销</div>
        <div @click="changeTabs('10')" :class="{'hover':queryParams.sourceType === '10'}">应用情况</div>
      </div>
      <ul>
        <li v-for="(item,index) in list" :key="index">
          <img src="../../../assets/home/liebiaoqian.png" alt="">
          <div v-if="queryParams.sourceType !== '10'" style="display: inline-block">
            <p v-if="item.newsType === 1" @click="goDetail(item.id)">{{ item.titleName }}</p>
            <p v-else @click="openUrl(item)">{{ item.titleName }}</p>
          </div>
          <div v-else  style="display: inline-block">
            <p @click="downloadReport(item)">{{ item.fileTitle }}</p>
          </div>
          <span class="fr">{{ item.showYearTime }}</span>
          <em v-if="(index+1)%5 === 0 && (index+1) !== list.length" class="xiaxuxian"></em>
        </li>
      </ul>
    </div>
    <div style="text-align: center;">
      <span
          style="vertical-align:middle;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
          @click="goFirst">首页</span>
      <el-pagination
          style="margin: 24px 0;display: inline-block;vertical-align:middle;"
          background
          prev-text="上一页"
          next-text="下一页"
          :page-size="queryParams.pageSize"
          :current-page="queryParams.pageNum"
          @current-change="changePage"
          layout="prev, pager, next,slot, total,jumper"
          :total="total">
        <span
            style="margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;background-color: rgb(244, 244, 245);font-weight: normal;cursor: pointer;"
            @click="goLast">末页</span>
      </el-pagination>
      <span
          style="margin-left:20px;color:#FFF;background-color:#D3131A;margin-right:10px;display: inline-block;width: 50px;height: 32px;text-align: center;line-height: 32px;font-weight: normal;cursor: pointer;">跳转</span>
    </div>
  </div>
</template>

<script>
import {
  batteryList,
  batteryReList,
  batteryReDetail
} from '@/api/hydrogen'

export default {
  data() {
    return {
      list: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 15,
        sourceType: '108',
        likeTitleName: ''
      },
      query: {
        pageNum: 1,
        pageSize: 15,
        sourceType: 11,
        fileType: '10',
      }
    }
  },
  created() {
    if (this.$route.query && this.$route.query.flag) {
      this.queryParams['sourceType'] = this.$route.query.flag
      this.query['fileType'] = this.$route.query.flag
    }
    this.getList();
  },
  methods: {
    // 获取列表
    getList() {
      if (this.queryParams['sourceType'] !== '10') {
        batteryList(this.queryParams).then(res => {
          this.list = res.rows;
          this.total = res.total;
        })
      } else {
        batteryReList(this.query).then(res => {
          this.list = res.rows;
          this.total = res.total;
        })
      }
    },
    /**
     * 搜索
     */
    search() {
      this.queryParams['pageNum'] = 1;
      this.query['pageNum'] = 1;
      this.getList()
    },
    /**
     * 前往详情页
     */
    goDetail(id) {
      this.$router.push({path: `/hydrogen/battery`, query: {id: id, flag: this.queryParams['sourceType']}})
    },
    /**
     * 切换tabs
     */
    changeTabs(num) {
      this.queryParams['sourceType'] = num;
      this.queryParams['pageNum'] = 1;
      this.queryParams['likeTitleName'] = ''
      this.query['fileType'] = num;
      this.query['pageNum'] = 1;
      this.query['likeFileTitle'] = '';
      this.getList();
    },
    /**
     * 下载文件
     */
    downloadReport(row) {
      batteryReDetail(row['id'] + "/1").then((res) => {
        this.$setMenuInfoPath(['氢能', '燃料电池', '应用情况'], row['id']);
      })
    },
    /**
     *  行业动态外链
     */
    openUrl(item) {
      window.openUrl(item.newsContent)
    },
    /**
     * 回退
     */
    back() {
      this.$router.push('/hydrogen')
    },
    /**
     * 分页
     */
    goFirst() {
      this.queryParams['pageNum'] = 1;
      this.query['pageNum'] = 1;
      this.getList()
    },
    goLast() {
      this.queryParams['pageNum'] = Math.ceil(this.total / 15);
      this.query['pageNum'] = Math.ceil(this.total / 15);
      this.getList()
    },
    changePage(page) {
      this.queryParams['pageNum'] = page;
      this.query['pageNum'] = page;
      this.getList()
    },
  }
}
</script>

<style scoped lang="less">
@import "../../../style/twoPage";
</style>
